import React, { useEffect, useState } from "react";
import { ReactComponent as Sun } from "../../assets/images/Sun.svg";
import { ReactComponent as Moon } from "../../assets/images/Moon.svg";
import "./style.min.css";

const DarkMode = () => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem("selectedTheme");
    return saved ? saved === "dark" : false; //  Light par défaut
  });

  useEffect(() => {
    const theme = isDark ? "dark" : "light";
    document.querySelector("body").setAttribute("data-theme", theme);
    localStorage.setItem("selectedTheme", theme);
  }, [isDark]);

  const toggleTheme = (e) => {
    setIsDark(e.target.checked);
  };

  return (
    <div className="dark_mode">
      <input
        className="dark_mode_input"
        type="checkbox"
        id="darkmode-toggle"
        onChange={toggleTheme}
        checked={isDark}
      />
      <label
        className="dark_mode_label"
        htmlFor="darkmode-toggle"
        aria-label="Changer le mode sombre"
      >
        <Sun />
        <Moon />
      </label>
    </div>
  );
};

export default DarkMode;
